import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function ErrorPage() {
    const { t } = useTranslation('translation', {
        keyPrefix: 'ERROR_PAGE'
    });
    const errorMessage = getErrorMessage(useRouteError(), t);
    return (_jsxs("div", { id: "error-page", children: [_jsx("h1", { children: t('HEADING') }), _jsx("p", { children: t('MESSAGE') }), _jsx("p", { children: _jsx("i", { children: errorMessage }) })] }));
}
function getErrorMessage(error, t) {
    let errorMessage;
    if (isRouteErrorResponse(error)) {
        errorMessage = error.statusText;
    }
    else if (error instanceof Error) {
        errorMessage = error.message;
    }
    else if (typeof error === 'string') {
        errorMessage = error;
    }
    else {
        errorMessage = t('UNKNOWN_ERROR');
    }
    return errorMessage;
}
